import { User } from "./User";
import { Vehicle } from "./Vehicle";

export class Voucher {
  _id: string;
  id: number;
  tankId: number;
  description?: string;
  initDate?: Date;
  expirationDate?: Date;
  amount?: number;
  available?: number;
  status?: string;
  operator: number;
  operator_name: String
  operators: any;
  vehicle: number;
  vehicles: any;
  km_is_active: boolean;
  sync_date: Date;
  createdAt?: Date;
  single_use?: boolean;
}

export enum VoucherStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  FINISHED = 'FINISHED',
  CANCELED = 'CANCELED',
  EXPIRED = 'EXPIRED'
}
